import React, { Component } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'

import Input from '../../../form/Input'
import Button from '../../../../UniformComponents/Button'

@observer
class Options extends Component {
    constructor(props) {
        super(props)

        const {
            store,
        } = props
        const { customTag } = store

        if (R.isNil(customTag.config.answerOptions)) {
            customTag.config.answerOptions = []
        }
    }

    componentWillUnmount() {
        const {
            unregister,
            name,
            path,
        } = this.props

        if (typeof unregister === 'function') {
            unregister(name, path)
        }
    }

    isAdminTag = () => {
        const { store } = this.props
        const { customTag } = store

        return customTag.options.includes('adminTag')
    }

    validate = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { answerOptions } = config

        return answerOptions.every(({ config: { langs } }) => (
            !R.isNil(langs.en_GB)
            && !R.isEmpty(langs.en_GB)
        ))
    }

    addOption = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { answerOptions } = config

        const options = answerOptions.slice()
        options.push({
            uuid: uuidv4(),
            config: {
                langs: {
                    en_GB: '',
                },
            },
        })

        config.answerOptions = options
    }

    removeOption = (optionId) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { answerOptions } = config

        const filteredOptions = answerOptions
            .slice()
            .filter(({ uuid }) => uuid !== optionId)

        config.answerOptions = filteredOptions
    }

    onBlur = ({ value, name }) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { answerOptions } = config

        const options = answerOptions.slice()

        const optionIndex = options.findIndex(({ uuid }) => uuid === name)
        const option = cloneDeep(options[optionIndex])
        option.config.langs.en_GB = value

        options.splice(optionIndex, 1, option)

        config.answerOptions = options
    }

    renderOptions = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { answerOptions } = config
        const canAddOption = !this.isAdminTag() || answerOptions.length === 0

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                {answerOptions.map(({ uuid, config: { langs: { en_GB: label } } }) => (
                    <div
                        key={uuid}
                        style={{
                            display: 'flex',
                            gap: '10px',
                            alignItems: 'center',
                        }}
                    >
                        <Input
                            name={uuid}
                            defaultValue={label}
                            onBlur={this.onBlur}
                            isMandatory
                        />
                        <i
                            className="fal fa-trash"
                            style={{ fontSize: '18px', cursor: 'pointer' }}
                            onClick={() => this.removeOption(uuid)}
                        />
                    </div>
                ))}
                {canAddOption && (
                    <div>
                        <Button
                            label={i18n.t('customTag.mergefield.addOption')}
                            onClick={this.addOption}
                            cssClass="primary secondary"
                        />
                    </div>
                )}
            </div>
        )
    }

    render() {
        return (
            <fieldset id="options">
                <legend>{i18n.t(this.isAdminTag() ? 'customTag.edit.adminTagName' : 'customTag.edit.options')}</legend>
                {this.renderOptions()}
            </fieldset>
        )
    }
}

export default Options
